import http from './http';
import { wOrgIdMiddleware } from '../utils/commonUtils';
import { CREATED, OK, UNPROCESSABLE_CONTENT } from '../utils/constant';

const NotificationTemplateService = {
    getList:wOrgIdMiddleware( async (url='',queryStrings) => {
        try {
            const queryString = new URLSearchParams(queryStrings).toString();
            const response = await http.GET(`${url}notification-templates?${queryString}`);
            console.log("Notification Template List Response:", response);
            if (response.code === OK && response.data) {
                return response.data;
            }
            return null;
        } catch (error) {
            console.error('Error fetching Notification Template list:', error);
            throw error;
        }
    },true),
    getById: wOrgIdMiddleware(async (url="",id) => {
        try {
            const response = await http.GET(`${url}notification-templates/${id}`);
            console.log("Notification Template By ID Response:", response);
            if (response.code === OK && response.data) {
                return response.data;
            }
            return null;
        } catch (error) {
            console.error('Error fetching Notification Template by ID:', error);
            throw error;
        }
    },true),
    createTemplate: wOrgIdMiddleware(async (url='',data) => {
        try {
            console.log("crearte",url,data);
            
            const response = await http.POST(`${url}notification-templates`, data);
            console.log("Create Notification Template Response:", response);
            if ((response.code === OK || response.code === CREATED) && response.data) {
                return response
            }else if(response.code==UNPROCESSABLE_CONTENT && response.data){
                return response;
            }
            return null;
        } catch (error) {
            console.error('Error creating Notification Template:', error);
            throw error;
        }
    },true),
    updateTemplate: wOrgIdMiddleware(async (url='',id,data) => {
        try {
            const response = await http.PUT(`${url}notification-templates/${id}`, data);
            console.log("Update Notification Template Response:", response);
             if ((response.code === OK || response.code === CREATED) && response.data) {
                return response
            }else if(response.code==UNPROCESSABLE_CONTENT && response.data){
                return response;
            }
            return null;
        } catch (error) {
            console.error('Error updating Notification Template:', error);
            throw error;
        }
    },true),
    deleteTemplate: wOrgIdMiddleware(async (url='',id) => {
        try {
            const response = await http.DELETE(`${url}notification-templates/${id}`);
            console.log("Delete Notification Template Response:", response);
            if (response.code === OK && response.data) {
                return response.data;
            }
            return null;
        } catch (error) {
            console.error('Error deleting Notification Template:', error);
            throw error;
        }
    },true),
    gettemplate: wOrgIdMiddleware(async (url='',data) => {
        try {
            const response = await http.POST(`${url}get-notification-template`,data);
            console.log("Get Template Message Response:", response);
            if (response.code === OK && response.data) {
                return response.data;
            }
            return null;
        } catch (error) {
            console.error('Error fetching Template Message:', error);
            throw error;
        }
    },true),
};

export default NotificationTemplateService;
